import React from "react";
import Logo from "../assets/Logo_Solo_White (2).png";

const LoginLeft = () => {
  return (
    <div className="hidden md:flex flex-col justify-center items-center bg-black text-white w-1/2 h-screen p-12 relative overflow-hidden">
      {/* Subtle background graphs */}
      <div className="absolute inset-0 opacity-10">
        {/* Line chart in top left */}
        <div className="absolute top-16 left-16 w-40 h-24">
          <svg viewBox="0 0 160 96" className="w-full h-full stroke-white fill-none stroke-1">
            <polyline points="0,80 20,60 40,70 60,40 80,50 100,20 120,30 140,10 160,25" />
            <circle cx="0" cy="80" r="1" className="fill-white" />
            <circle cx="40" cy="70" r="1" className="fill-white" />
            <circle cx="80" cy="50" r="1" className="fill-white" />
            <circle cx="120" cy="30" r="1" className="fill-white" />
            <circle cx="160" cy="25" r="1" className="fill-white" />
          </svg>
        </div>

        {/* Bar chart in bottom right */}
        <div className="absolute bottom-24 right-16 w-32 h-20">
          <svg viewBox="0 0 128 80" className="w-full h-full stroke-white fill-white stroke-1 opacity-60">
            <rect x="5" y="60" width="8" height="20" />
            <rect x="18" y="45" width="8" height="35" />
            <rect x="31" y="35" width="8" height="45" />
            <rect x="44" y="50" width="8" height="30" />
            <rect x="57" y="25" width="8" height="55" />
            <rect x="70" y="40" width="8" height="40" />
            <rect x="83" y="20" width="8" height="60" />
            <rect x="96" y="30" width="8" height="50" />
            <rect x="109" y="15" width="8" height="65" />
          </svg>
        </div>

        {/* Small pie chart in top right */}
        <div className="absolute top-1/3 right-1/4 w-16 h-16">
          <svg viewBox="0 0 64 64" className="w-full h-full stroke-white fill-none stroke-1">
            <circle cx="32" cy="32" r="20" className="opacity-40" />
            <path d="M 32,12 A 20,20 0 0,1 45.66,20" className="stroke-2 opacity-80" />
            <path d="M 45.66,20 A 20,20 0 0,1 52,32" className="stroke-2 opacity-60" />
            <path d="M 52,32 A 20,20 0 0,1 32,52" className="stroke-2 opacity-40" />
          </svg>
        </div>

        {/* Network nodes in middle left */}
        <div className="absolute top-1/2 left-8 w-24 h-20 transform -translate-y-1/2">
          <svg viewBox="0 0 96 80" className="w-full h-full stroke-white fill-white stroke-1 opacity-30">
            <line x1="10" y1="20" x2="30" y2="35" />
            <line x1="30" y1="35" x2="60" y2="15" />
            <line x1="30" y1="35" x2="50" y2="60" />
            <line x1="60" y1="15" x2="80" y2="45" />
            <line x1="50" y1="60" x2="80" y2="45" />
            <circle cx="10" cy="20" r="2" />
            <circle cx="30" cy="35" r="2" />
            <circle cx="60" cy="15" r="2" />
            <circle cx="50" cy="60" r="2" />
            <circle cx="80" cy="45" r="2" />
          </svg>
        </div>
      </div>

      <div className="flex flex-col items-center space-y-16 w-full max-w-md z-10">

        {/* Enhanced Branding */}
        <div className="flex flex-col items-center space-y-6 group">
          {/* Logo container with hover effect */}
          <div className="relative">
            <div className="flex items-center justify-center w-28 h-28 bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl shadow-2xl border border-gray-700 transition-all duration-500 group-hover:scale-105 group-hover:shadow-3xl group-hover:border-gray-600">
              <img src={Logo} alt="Tetra Logo" className="w-20 h-20 object-contain transition-transform duration-500 group-hover:scale-110" />
            </div>
            {/* Glow effect */}
            <div className="absolute inset-0 bg-white rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity duration-500 blur-xl"></div>
          </div>

          {/* Brand name with staggered animation */}
          <div className="text-center">
            <h1 className="text-6xl font-black tracking-tight mb-2 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
              TETRA
            </h1>
            <p className="text-3xl font-extralight text-brand-400 tracking-[0.3em] transform transition-all duration-700 hover:tracking-[0.4em] hover:text-brand-300">
              MOTORS
            </p>
          </div>

          {/* Enhanced divider */}
          <div className="relative mt-4">
            <div className="h-0.5 w-32 bg-gradient-to-r from-transparent via-brand-500 to-transparent"></div>
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-2 h-0.5 bg-brand-400 shadow-lg shadow-brand-500/50"></div>
          </div>
        </div>

        {/* Enhanced Tagline */}
        <div className="text-center space-y-4">
          <p className="text-gray-200 text-xl font-light tracking-wide leading-relaxed">
            Intelligence meets Performance
          </p>
          <p className="text-gray-500 text-base font-normal max-w-sm leading-relaxed">
            Advanced AI-powered Charging Station Management System
          </p>
          <div className="text-gray-600 text-xs uppercase tracking-widest font-medium mt-3">
            (CSMS)
          </div>
        </div>

        {/* Minimalist footer element */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
          <div className="flex space-x-2">
            <div className="w-2 h-2 bg-brand-500 rounded-full"></div>
            <div className="w-2 h-2 bg-gray-400 rounded-full opacity-40"></div>
            <div className="w-2 h-2 bg-gray-600 rounded-full opacity-20"></div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default LoginLeft;